module.exports = __webpack_public_path__ + "static/media/calzado1.9f0c553c.png";